export function useEase(ease) {
   switch (ease) {
      case 'easeOutQuart':
         [0.25, 1, 0.5, 1]
         break;

      case 'easeInQuart':
         [0.5, 0, 0.75, 0]
         break;

      case 'easeInOutQuart':
         [0.76, 0, 0.24, 1]
         break;

      case 'easeInExpo':
         [0.7, 0, 0.84, 0]
         break;

      case 'easeOutExpo':
         [0.16, 1, 0.3, 1]
         break;

      case 'easeOutBack':
         [0.34, 1.56, 0.64, 1]
         break;
   }
}

export const animeRandom = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

export const mix = (from, to, progress) => -progress * from + progress * to + from

export const randomInt = (min, max) => mix(min, max, Math.random())